package com.islamicmedia.shared.data.api

import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.HttpTimeout
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json

actual fun createHttpClient(): HttpClient = HttpClient(Js) {
    install(ContentNegotiation) {
        json(Json {
            ignoreUnknownKeys = true
            isLenient = true
        })
    }
    install(HttpTimeout) {
        requestTimeoutMillis = 600_000
        connectTimeoutMillis = 60_000
        socketTimeoutMillis = 600_000
    }
}

actual fun serverBaseUrl(): String = com.islamicmedia.shared.AppConfig.SERVER_BASE_URL
